import { Application } from '@hotwired/stimulus'
import RevealController from '@stimulus-components/reveal'
import Dropdown from '@stimulus-components/dropdown'
import CustomUploadController from './custom-upload_controller'
import RailsNestedForm from '@stimulus-components/rails-nested-form'
import SdgGoalsController from './sdg_goals_controller'
import AccordionController from './accordion_controller'
import RadarChartController from './radar_chart_controller'
import RevenueCalculator from './revenue_calculator_controller'

const application = Application.start()
application.register('reveal', RevealController)
application.register('dropdown', Dropdown)
application.register('custom-upload', CustomUploadController)
application.register('nested-form', RailsNestedForm)
application.register('sdg-goals', SdgGoalsController)
application.register('accordion', AccordionController)
application.register('radar-chart', RadarChartController)
application.register('revenue-calculator', RevenueCalculator)